

import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import LoadingGif from '../../../../../static/images/loading.gif'

class CreateEmailFormView extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
        };
    }


    
    render(){
        return(
            <Form id = "createEmailForm" noValidate validated = {this.props.isEmailValid} onSubmit = {this.props.handleFormSubmit}>
            {/* <div id="requiredDiv"><span id="required"><span id="redStar">*</span>Required</span></div> */}
            <Form.Group id = "createEmailLocalGroup" className = "relative">
                {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                in order to disable native popup error*/}
                <Form.Label className = {`${this.props.floatLabel ? "absolute floating-label" : "absolute inline-label" }
                 ${this.props.onFocus === true ? "label-black__TO" : "" }
                 ${this.props.isEmailValid === false && this.props.onFocus === false ? "label-red__TO" : ""}
                
                `}>
                Email
                <span id="redStar">*</span></Form.Label>
                <Form.Control
                    required
                    id = "createEmailLocal__TO"
                    data-testid = "createEmail"
                    aria-label = "Email"
                    as = "input"
                    type = "text"
                    name = "email"
                    placeholder = ""
                    value = {this.props.email}
                    onChange = {this.props.handleEmailChange}
                    onFocus = {this.props.setFocus}
                    onBlur = {this.props.onBlur}
                    bsPrefix = {`${this.props.isEmailValid === false && this.props.onFocus === false ? "highlight-error__TO form-control" : ""}`}
                />
            <div
                id = "createEmailAlert" 
                data-testid = "createEmailError" 
                className = {`logon-item-error__TO ${this.props.isEmailValid === false && this.props.onFocus === false ? "block" : "none"}`} 
                role = "alert"
                aria-hidden = {`${this.props.isEmailValid === false && this.props.onFocus === false ? "false" : "true"}`}
            >
                Please enter a valid email address.
            </div>
            </Form.Group>
            <div className="requiredDiv__TO"><span className = "required"><span id="redStar">*</span>Required</span></div>
            <div className = "username-button-grid">
            <Button data-testid = "createEmailButton" bsPrefix = {`${(this.props.isEmailValid) !== true ? "button-disabled__TO" : "button__TO "}`} type = "submit" >Next Step</Button>
            </div>

            <Image data-testid = "loadingGIF" className = {`working ${this.props.loading ? "" : "none"}`} id = "loadingGIF" src={LoadingGif} aria-hidden = "true"/>
        </Form>
    );

    }

}

export default CreateEmailFormView;